import { useEffect } from 'react';

import { useUserStore } from '@/stores/user/userStore';

/** Must match persist `name` in `userStore.js` */
const USER_PERSIST_KEY = 'user';

/**
 * Keeps auth in sync when another tab logs in, logs out, or clears storage.
 * Without this, Zustand state stays stale while localStorage already changed.
 */
export function useUserStoreCrossTabSync() {
  useEffect(() => {
    const onStorage = (e) => {
      if (e.storageArea !== localStorage) return;

      // Another tab wrote updated auth — merge from localStorage into this tab.
      if (e.key === USER_PERSIST_KEY && e.newValue) {
        void useUserStore.persist.rehydrate();
        return;
      }

      // User key removed (logout / removeItem) — rehydrate alone may not clear merged state.
      if (e.key === USER_PERSIST_KEY && e.newValue === null) {
        window.location.reload();
        return;
      }

      // localStorage.clear() in another tab — reload so we don't keep a stale in-memory session.
      if (e.key === null && !localStorage.getItem(USER_PERSIST_KEY)) {
        window.location.reload();
      }
    };

    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
}
